import { useEffect } from 'react';
import { useSearchParams } from 'react-router';
export function BentleyLoginExtend() {
    const [searchParams] = useSearchParams();
    const authCode = searchParams.get('code');
    const state = searchParams.get('state');
    const error = searchParams.get('error');
    useEffect(() => {
        if (state) {
            const bc = new BroadcastChannel(`extend_login.${state}`);
            bc.postMessage({ source: 'bentley-login-extension', code: authCode, state, error });
            bc.close();
        }
        window.close();
    }, []);
    return 'Successfully logged in!';
}
//# sourceMappingURL=BentleyLoginExtend.js.map